// Per-device display preferences (theme, accent, density), stored in localStorage.
export type Theme = "system" | "light" | "dark";
export type Accent = "blue" | "teal" | "purple" | "rose" | "amber";
export type Density = "comfortable" | "compact";

const get = <T extends string>(k: string, d: T): T => {
  try { return (localStorage.getItem(k) as T) || d; } catch { return d; }
};
export const prefs = () => ({
  theme: get<Theme>("pref.theme", "system"),
  accent: get<Accent>("pref.accent", "blue"),
  density: get<Density>("pref.density", "comfortable"),
});

export function applyPrefs() {
  const p = prefs();
  const el = document.documentElement;
  if (p.theme === "system") el.removeAttribute("data-theme"); else el.dataset.theme = p.theme;
  el.dataset.accent = p.accent;
  el.dataset.density = p.density;
}

export function setPref(k: "theme" | "accent" | "density", v: string) {
  try { localStorage.setItem(`pref.${k}`, v); } catch { /* private mode: just apply for this page */ }
  applyPrefs();
}
